<script setup lang="ts">
  import { useLoginStore } from "~/stores/LoginStore";
  import { useContentsStore } from "~/stores/ContentsStore";
  interface Props {
    contentId: string | undefined;
    isGooded: boolean;
    count: number;
    clickable: boolean;
    color?: string;
  }
  const props = defineProps<Props>();
  const loginStore = useLoginStore();
  const clickableGood = computed<boolean>(() => props.clickable && loginStore.isLogin());
  const contentsStore = useContentsStore();
  // いいね処理中かどうか
  const isGooding = ref<boolean>(false);

  const goodCountToShow = ref<number>(props.count);
  const isGoodedToShow = ref<boolean>(props.isGooded);

  // いいねボタンクリック
  const onClickGood = async () => {
    if (!clickableGood.value) {
      return;
    }
    if (!props.contentId) {
      return;
    }
    // 連打防止
    if (isGooding.value) {
      return;
    }
    isGooding.value = true;

    try {
      if (isGoodedToShow.value) {
        await contentsStore.deleteGood(props.contentId);
        goodCountToShow.value -= 1;
      } else {
        await contentsStore.postGood(props.contentId);
        goodCountToShow.value += 1;
      }
      isGoodedToShow.value = !isGoodedToShow.value;
    } catch (error: any) {
      sentryErrorLog(`コンテンツいいねエラー: ${error}`);
    } finally {
      isGooding.value = false;
    }
  };

  const textColor = computed<string>(() => {
    if (props.color) {
      return `text-${props.color}`;
    }
    return "";
  });
</script>

<template>
  <div
    class="good-button d-flex"
    :class="[isGoodedToShow ? `gooded` : `not-gooded ${textColor}`, clickableGood ? 'cursor-pointer' : '']"
    @click.stop.prevent="onClickGood"
  >
    <v-icon v-if="isGoodedToShow" icon="$mdiThumbUp" :size="18" />
    <v-icon v-else icon="$mdiThumbUpOutline" :size="18" />
    <div class="good-count">{{ goodCountToShow.toLocaleString() }}</div>
  </div>
</template>

<style lang="scss" scoped>
  .good-button {
    border-radius: 15px;
    height: 30px;
    padding: 6px 12px;
    font-size: 10px;
    font-weight: 700;
    line-height: 24px; // アイコンがズレるので個別に指定
  }
  .good-count {
    margin-top: -3px;
    margin-left: 8px;
  }
  .gooded {
    color: rgb(var(--v-theme-main-01));
    background-color: rgb(var(--v-theme-monochrome-01));
  }
  .not-gooded {
    background-color: rgb(var(--v-theme-monochrome-03));
  }
</style>
